import {
  AbstractControl,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';

const getToday = () => {
  const date = new Date();
  return {
    date: {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate(),
    },
  };
};

// at least one of audiences are required
const audienceOrMailingListRequired: ValidatorFn = (group: UntypedFormGroup): {[s: string]: boolean} => {
  if (group) {
    if (group.controls['mailingLists']['controls'][0] || group.controls['targetAudience'].value) {
      return null;
    }
  }
  return {error: true};
};

export const EmailsForm = new UntypedFormGroup(
  {
    event: new UntypedFormControl('', Validators.required),
    subject: new UntypedFormControl('', Validators.required),
    message: new UntypedFormControl('', Validators.required),
    template: new UntypedFormControl('', Validators.required),
    targetAudience: new UntypedFormControl(''),
    lastUsedDate: new UntypedFormControl(getToday(), Validators.required),
    lastUsed: new UntypedFormControl(new Date().toISOString(), Validators.required),
    mailingLists: new UntypedFormArray([]),
    force_send: new UntypedFormControl(false),
  },
  audienceOrMailingListRequired,
);
